import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalSubmitFeedbackCollector: ExperimentalMutations['experimentalSubmitFeedbackCollector'] =
	(_, { summary, description, component }, { network }) => {
		const ATLASSIAN_STAFF_SECURITY_ID = '10750';
		const LOW_SYMPTOM_SEVERITY_ID = '14432';
		const AUTHENTICATION_ERROR =
			'com.atlassian.integration.jira.JiraAuthenticationRequiredException';

		let serverId: string;
		const body = {
			issues: [
				{
					fields: {
						project: {
							key: 'CONFCLOUD',
						},
						summary,
						description,
						issuetype: {
							name: 'Bug',
						},
						components: [{ name: component }],
						security: { id: ATLASSIAN_STAFF_SECURITY_ID },
						//customfield_17130: Symptom Severity, always set to low
						customfield_17130: { id: LOW_SYMPTOM_SEVERITY_ID },
					},
				},
			],
		};

		return fetchJSON(network, `/wiki/rest/createjiracontent/1.0/get-jira-servers`, {
			method: 'GET',
		}).then((data) => {
			const jacServer = data.find((server: any) =>
				server.url.includes('https://jira.atlassian.com'),
			);
			if (!jacServer) {
				throw new Error(`No JAC server available`);
			}
			serverId = jacServer.id;
			return fetchJSON(
				network,
				`/wiki/rest/jira-integration/1.0/issues?applicationId=${serverId}`,
				{
					method: 'POST',
					headers: { 'Content-Type': MediaType.JSON },
					body: JSON.stringify(body),
				},
			).then((data) => {
				const { errors } = data;
				const issue = data?.issues?.[0]?.issue;
				if (errors || !issue) {
					const isAuthenticationError = errors.find(
						(error: any) => error.exceptionName === AUTHENTICATION_ERROR,
					);
					if (isAuthenticationError) {
						return {
							id: null,
							key: null,
							self: null,
							authUrl: `/wiki/plugins/servlet/applinks/oauth/login-dance/authorize?applicationLinkID=${serverId}`,
						};
					}
					const errorMessage = errors.map((error: any) => ({
						...error?.elementErrors?.errors,
					}));
					throw new Error(JSON.stringify(errorMessage));
				}
				const { id, key, self } = issue;
				return {
					id,
					key,
					self,
					authUrl: null,
				};
			});
		});
	};
